module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('i', [_vm._v("This book is dedicated, as in all things in my life, to my children, Lynne, Leigh, Nedal and Suna, who have always given me the sense of purpose I need to reach for the heights.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_c('i', [_vm._v("Thanks to family and friends who gave me the love and support I needed to make it to the last page.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_c('i', [_vm._v("And a special nod to everyone who has ever stepped foot on a stage; without them the world would be a much less colorful place.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5ae74a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dedication.vue
// module id = 69
// module chunks = 0